import { createPassword } from './reducers';
export default createPassword;
